import React from 'react';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { getStatusColor, getShownState } from '../contractingUtils';
import RedDot from '../../tc-ui/redDot';
import { IconButton, Avatar, Card, CardHeader, CardText, FontIcon, Checkbox, RaisedButton } from 'material-ui';
import SignedIcon from 'material-ui/svg-icons/editor/border-color';
import moment from 'moment';
import R from 'ramda';

const styles = StyleSheet.create({
  container: { height: '56px', display: 'flex', paddingLeft: '16px', borderBottom: '1px solid rgba(0, 0, 0, 0.1)', alignItems: 'center' },
  texts: { color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer', marginLeft: '4px' },
  profileImage: { width: '7%', textAlign: 'left' },
  companyName: { fontSize: '13px', display: 'flex', alignItems: 'center' },
  locationName: { fontSize: '11px' },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: { display: 'flex', color: 'rgba(0, 0, 0, 0.77)', flexDirection: 'column', textAlign: 'right', width: '10%' },
  comments: { display: 'inline-block', marginLeft: '8px', width: '4%', cursor: 'pointer' },
});
const SimpleContractList = ({ contracts = [], header, viewingBy, style, inRequest = {} }, context) => {
  const {
    fileContractForRequest,
    // removeContractFromRequest,
    removingContractIds = [],
    filingContractId,
    requestId,
    onCheckContract,
    allCheckedIds,
    hideBtns,
  } = inRequest;
  return (
    <div>
      <div style={{ width: '90%', margin: 'auto', ...style }}>
        <Card style={{ margin: '16px auto', display: contracts.length ? 'block' : 'none' }} initiallyExpanded>
          <CardHeader
            style={{ width: '100%', padding: '6px', display: header ? 'inherit' : 'none' }}
            textStyle={{ padding: 0 }}
            title={
              <div
                style={{ height: '40px', lineHeight: '40px', paddingLeft: '16px', fontSize: '16px', display: 'flex', justifyContent: 'space-between' }}
              >
                {header}
              </div>
            }
            actAsExpander
          />
          <CardText expandable>
            {
              contracts.map((contract, i) => {
                const displayState = getShownState({ companyType: viewingBy, ...contract });
                const {
                  nameToDisplay,
                  logoToDisplay,
                } = (() => {
                  if (requestId && contract.versions.indexOf(requestId) === -1) {
                    return {
                      nameToDisplay: contract.from.emailAlias || contract.from.email,
                      logoToDisplay: contract.from.avatar,
                    };
                  }
                  if (contract.viewerIsSender) {
                    return {
                      nameToDisplay: contract.to.name,
                      logoToDisplay: contract.to.avatar,
                    };
                  }
                  // if viewer is receiver
                  // display based receiver's partner list
                  const partner = contract.partners[0] || {};
                  return {
                    nameToDisplay: partner.name || contract.from.name,
                    logoToDisplay: partner.avatar || contract.from.avatar,
                  };
                })();
                return (
                  <div
                    className={css(styles.container)}
                    key={i}
                    style={removingContractIds.indexOf(contract._id) > -1 ? { filter: 'blur(2px)' } : {}}
                  >
                    {
                      // requestId ? (
                      //   <div className={css(styles.profileImage)}>
                      //     <Checkbox
                      //       checked={allCheckedIds.indexOf(contract._id) > -1}
                      //       onCheck={onCheckContract(contract._id)}
                      //     />
                      //   </div>
                      // ) : (
                      //   <div className={css(styles.profileImage)}>
                      //     {
                      //       R.call(R.cond([
                      //         [() => logoToDisplay, R.always(<Avatar src={logoToDisplay} style={{ marginTop: '4px' }}/>)],
                      //         [R.T, R.always(<Avatar>{R.head(nameToDisplay || '')}</Avatar>)],
                      //       ]))
                      //     }
                      //   </div>
                      // )
                    }
                    <div
                      className={css(styles.texts)}
                      style={{ width: '70%' }}
                      onClick={() => context.router.push(`/contracting/contract/${contract._id}/details`)}
                    >
                      <div className={css(styles.companyName)}>
                        {nameToDisplay} {contract.versions.length <= 1 ? '' : `(v.${contract.versions.length + 1})`}
                        {Boolean(contract.signatures && contract.signatures.length) && (
                          <span className="hint--top" aria-label="Signed">
                            &nbsp;&nbsp;
                            <SignedIcon style={{ height: '18px', width: '18px', color: '#2e7d32' }} />
                          </span>
                        )}
                      </div>
                      <div className={css(styles.locationName)}>
                        <FontIcon className="tc-icon-location_on" style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '8px' }} />
                        {contract.locationName}
                        {
                          R.path(['supplierInfo', 'marketInfo'], contract) ? (<small>
                            &nbsp;{`(${R.path(['supplierInfo', 'marketInfo'], contract)})`}
                          </small>) : <span/>
                        }
                        {
                          (contract.hasDraft && contract.viewingBy === 'Supplier') || (contract.templateHasDraft && contract.templateFromDummy) ? (<span
                            style={{ marginLeft: '12px', color: 'red' }}
                          >
                          This contract has a draft.
                        </span>) : <span/>
                        }
                      </div>
                    </div>
                    <div className={css(styles.comments)} onClick={() => context.router.push(`/contracting/contract/${contract._id}/activities`)}>
                      <IconButton iconClassName="tc-icon-question_answer" className={css(styles.commentsButton)} iconStyle={{ color: 'rgba(0, 0, 0, 0.54)' }} />
                      { contract[viewingBy === 'Supplier' ? 'supplierHasNewComments' : 'buyerHasNewComments'] ? <RedDot/> : <span/>}
                    </div>
                    <div style={{ color: getStatusColor(displayState), width: '10%', textAlign: 'center' }}>
                      {displayState}
                    </div>
                    <div className={css(styles.yearNtimestamp)}>
                      <span style={{ fontSize: '11px', color: 'rgba(0, 0, 0, 0.45)' }}>{moment(contract.createdAt).calendar(null, {
                        sameDay: 'h:mm a',
                        lastDay: 'D MMM YY',
                        lastWeek: 'D MMM YY',
                        sameElse: 'D MMM YY',
                      })}</span>
                    </div>
                    {
                    // Boolean(requestId && !hideBtns) && (
                    //   <div style={{ marginLeft: '8px' }} className="flex-center">
                    //     <RaisedButton
                    //       label={(() => {
                    //         if (contract.versions.indexOf(requestId) > -1) return 'Filed';
                    //         if (filingContractId === contract._id) return 'Processing';
                    //         return 'File Contract';
                    //       })()}
                    //       disabled={removingContractIds.indexOf(contract._id) > -1
                    //         || contract.versions.indexOf(requestId) > -1
                    //       }
                    //       secondary
                    //       onClick={fileContractForRequest(contract._id)}
                    //     />
                    //     { // only show REMOVE when contract is not filed
                    //       // !Boolean(
                    //       //   contract.versions.indexOf(requestId) > -1
                    //       //   || filingContractId === contract._id
                    //       // ) && (
                    //       //   <RaisedButton
                    //       //     style={{ marginLeft: '16px' }}
                    //       //     label={(() => {
                    //       //       if (removingContractIds.indexOf(contract._id) > -1) return 'Processing';
                    //       //       return 'Remove';
                    //       //     })()}
                    //       //     disabled={removingContractIds.indexOf(contract._id) > -1}
                    //       //     primary
                    //       //     onClick={removeContractFromRequest([contract._id])}
                    //       //   />
                    //       // )
                    //     }
                    //   </div>
                    // )
                    }
                  </div>
                );
              })
            }
          </CardText>
        </Card>
      </div>
    </div>
  );
};

SimpleContractList.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(({ user }) => ({ viewingBy: user.getIn(['user', 'type'])}))(SimpleContractList);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/simpleContractList.jsx